export default "__VITE_ASSET__ade7bce1__"